import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import classNames from "classnames";
import { toast } from "react-toastify";

import Analytics from "@web-solutions/module-analytics";

import { t } from "@web-solutions/module-localization";
import { useStore } from "../../../../../apps/virtual-brainary/src/onboarding/store/store";
import { Button } from "core/ui-elements";
import { Input } from "core/ui-elements";

import { useEmail } from "core/hooks/use-email";
import { useFocus } from "core/hooks/use-focus";

import { initOrders } from "core/store/billing/actions";

import { processEmail } from "src/store/profile/actions"; // TODO

import classes from "./style.module.scss";

import { ReactComponent as IconEdit } from "./icons/icon-edit.svg";
import { useRemoteConfig } from "@web-solutions/base-app/hooks/use-remote-config";
import axios from "axios";
import { getEnvUrl } from "../../../../../apps/virtual-brainary/src/onboarding/helpers/getEnvUrl";
import { applyFoodzeeAuthTokens } from "src/onboarding/helpers/applyFoodzeeAuthTokens";

const EmailEditor = ({ className = null, isSimpleView }) => {
  const dispatch = useDispatch();
  const email = useSelector((state) => state.profile.email);
  const isSubmitByCard = useSelector((state) => state.billing.isSubmitByCard);
  const [isLoading, setLoading] = useState(false);
  const userEmail = useStore((state) => state.email);
  const initialEmail = email || userEmail || "";
  const [value, isValid, setValue] = useEmail(initialEmail);
  const [isApply, setApply] = useState(!!initialEmail);
  const setUserId = useStore((state) => state.setUserId);

  useEffect(() => {
    const currentEmail = email || userEmail || "";
    if (currentEmail) {
      setValue(currentEmail);
      setApply(true);
    }
  }, [email, userEmail]);

  const isPresenceEmail =
    (isSubmitByCard && value.length < 1) ||
    (isSubmitByCard && !isValid) ||
    (isSubmitByCard && !isApply);
  const [inputRef, setInputFocus] = useFocus();
  const { paymentPopup, newPaymentModal, paymentSystem } = useRemoteConfig();
  const setEmail = useStore((state) => state.setEmail);
  const currentPage = useStore((state) => state.currentPage);
 
  useEffect(() => {
    if (isPresenceEmail) {
      setInputFocus();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isPresenceEmail]);

  const handleInputChange = (e) => {
    const val = e.target.value;
    if (val !== email) {
      setApply(false);
    }
    setValue(val);
  };
  const { apiBaseUrl } = getEnvUrl();

  const handleButtonClick = async (e) => {
    e.preventDefault();
    Analytics.trackEvent("edit_customer_email", "btn_click");

    if (isApply || !isValid) {
      setApply(false);
      return;
    }

    try {
      setValue(value);
      setLoading(true);
      if (value !== email) {
        dispatch(processEmail(value));
        setEmail(value);
        Analytics.trackEvent("edit_customer_email", "success");
        dispatch(initOrders());

        if (currentPage === 'paywall') {
          const payload = {
            email: value,
          };
  
          const response = await axios.post(`${apiBaseUrl}/v2/user`, payload);
          if (response.status === 201) {
            setUserId(response.data.uid);
            applyFoodzeeAuthTokens(response.data, dispatch, { reinitBilling: true, paymentSystem });
          }
        }

      }
      setApply(true);
    } catch (error) {
      dispatch(processEmail());
      Analytics.trackEvent("edit_customer_email", "fail");
      const message = error?.data?.message
        ? error.data.message
        : t("core.errors.something_went_wrong");
      console.warn(error);
      toast(message);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmitForm = (e) => {
    Analytics.trackEvent("edit_customer", "email_input_enter_click");
    handleButtonClick(e);
  };

  const handleEditClick = (e) => {
    e.preventDefault();
    setApply(false);
  };

  const inputStyle = classNames(classes.input, {
    [classes.invalid]: isPresenceEmail || !value.length,
    [classes.inputNew]: newPaymentModal,
  });
  const locale = useSelector((state) => state.locale.locale);
  return (
    <div
      className={classNames(
        classes.wrapper,
        { [classes.applied]: isApply },
        className
      )}
    >
      {isApply ? (
        <button
          type="button"
          className={classes.editClickableWrap}
          onClick={handleEditClick}
        >
          <p
            className={
              newPaymentModal ? classes.descriptionNew : classes.description
            }
          >
            {paymentPopup.editEmail.title[locale]}:
          </p>
          <div className={classes.rightSide}>
            <p
              className={
                newPaymentModal ? classes.editEmailNew : classes.editEmail
              }
            >
              {value}
            </p>
            <IconEdit width={24} height={24} />
          </div>
        </button>
      ) : (
        <form action="#" onSubmit={handleSubmitForm} className={classes.form}>
          <Input
            ref={inputRef}
            autoFocus={isPresenceEmail}
            type="email"
            value={value}
            onChange={handleInputChange}
            className={inputStyle}
            placeholder={paymentPopup.editEmail.placeholder[locale]}
            name="email"
            id="email"
          />
          <Button
            type="submit"
            className={classNames(classes.formButton, {
              [classes.simple_view]: isSimpleView,
              [classes.buttonNew]: newPaymentModal,
            })}
            disabled={!isValid || isLoading}
            title={paymentPopup.editEmail.button[locale]}
            titleClassName={classes.formButtonTitle}
          />
        </form>
      )}
    </div>
  );
};

export default EmailEditor;
